export default __webpack_public_path__ + "static/media/kitap4.5a52c383.jpg";